import { GridColumnType } from "../../../data/gridColumnType";

export const XeroPaymentListConfig = {
  columns: [
    {
      name: "Company Name",
      fieldName: "companyName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Included Certs",
      fieldName: "includedCerts",
      colType: GridColumnType.Text,
    },
    {
      name: "Overseas Charge",
      fieldName: "overseasCharge",
      colType: GridColumnType.Text,
    },
    {
      name: "Invoice Number",
      fieldName: "invoiceNumber",
      colType: GridColumnType.Text,
    },

    {
      name: "Invoice Amount",
      fieldName: "totalAmount",
      colType: GridColumnType.Text,
    },
    {
      name: "Payment Date",
      fieldName: "date",
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },

    {
      name: "Actions",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
        otherAction: true,
      },
      colSetting: {
        btnText: "Send",
        isDisable: "isDisable",
        btnClassName: "xero-sendbtn",
        // onclick:(data) => {
        //     alert("Send action clicked");
        //   },
      },
      // customAction: [
      //   {
      //     name: "Send",
      //     onViewAction: (data) => {
      //       alert("Send action clicked");
      //     },
      //   },
      // ],
    },
  ],
};
